/* error.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 20 20" preserveAspectRatio="none">
                <path class="foreground-gl" d="M10,19.86a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,10,19.86ZM10,1.44A8.52,8.52,0,1,0,18.5,10,8.53,8.53,0,0,0,10,1.44Z" transform="translate(-0.08 -0.05)"/><path class="foreground-gl" d="M10,12.08a1.36,1.36,0,0,1-1.36-1.36V4.54a1.36,1.36,0,1,1,2.73,0v6.17A1.36,1.36,0,0,1,10,12.08Z" transform="translate(-0.08 -0.05)"/><circle class="foreground-gl" cx="9.88" cy="14.95" r="1.73"/>
            </svg>
         `,
};
